import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Select2OptionData } from 'ng2-select2';
import * as firebase from 'firebase';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  providers: [AngularFireAuth, AngularFireDatabase]
})
export class ProfileComponent implements OnInit {
  public statusOptions: Array<Select2OptionData>;
  public notificationOptions: Array<Select2OptionData>;

  user : any = {};
  moreOptions : boolean = false;
  usernameAvailable : boolean = true;
  usernameChecked : boolean = false;
  profile : any = {
    avatarUrl: 'https://chispa-ruralchispa-rural.firebaseapp.com/assets/img/avatar.png'
  };
  currentState : any = {};
  states : Observable<any[]>;
  options : any;
  nextPoints : any = 1;

  constructor(private afAuth: AngularFireAuth, private db : AngularFireDatabase, private router : Router) {}

  ngOnInit() {
    this.options = {
      multiple: true
    }

    this.statusOptions = [
      { id: 'working', text: 'Trabaja' },
      { id: 'studying', text: 'Estudia' },
      { id: 'enterpreneur', text: 'Tiene una idea de negocio' },
      { id: 'study-work', text: 'Estudia y Trabaja' }
    ];

    this.notificationOptions = [
      {id: 'scolarships', text: 'Becas'},
      {id: 'workshops', text: 'Capacitaciones'},
      {id: 'employment', text: 'Empleo'},
      {id: 'discussion', text: 'Grupos de Discusión'},
      {id: 'more', text: 'Otro'}
    ]

    this.afAuth.auth.onAuthStateChanged(user => {
      this.user = user;

      if (!user) this.router.navigate(['login']);
      this.db.object(`profiles/${this.user.uid}`, )
        .snapshotChanges().subscribe(snapshot => {
          this.profile.key = snapshot.key;
          Object.assign(this.profile, snapshot.payload.val());
        })
    });

    this.states = this.db.list('/states')
    .snapshotChanges()
    .map(changes => {
      return changes.map(c => ({ key: c.key, ...c.payload.val() }));
    });

  }

  setState(state) {
    this.profile.state = state.name;
  }

  setStatus(data: {value: string[]}) {
    this.profile.status = data.value;
  }

  save() {
    this.db.object('profiles/' + this.profile.userId)
      .update(this.profile)
      .then(response => {
        this.updateUsername()
        this.router.navigate([this.profile.userId]);
      })
      .catch(err => console.log(err));
  }

  uploadImage(files) {
    let storageRef = firebase.storage().ref();
    let success = false;

    let selectedFile = files.srcElement.files[0];
    let path = `/images/avatar/${selectedFile.name}`;
    let fileRef = storageRef.child(path);

    fileRef.put(selectedFile).then((snapshot) => {
      this.profile.avatarUrl = snapshot.metadata.downloadURLs[0];
    })
  }

  setNotifications(data: {value: string[]}) {
    if (data.value.indexOf('more') > -1) {
      this.moreOptions = true;
    }
    else {
      this.moreOptions = false;
    }

    this.profile.notifications = data.value;
  }

  getProgress() {
    if (this.user) {
      this.nextPoints = ((this.profile.rank || 0 ) + 1) * 1000;
      const progress = ((this.profile.points || 0) / this.nextPoints);

      return progress * 250;
    }
    return 0;
  }

  checkUsername(event : any) {
   let username = this.profile.username.toLowerCase();
   if ( username.length > 3) {
     this.usernameChecked = true;
     this.db.object(`usernames/${username}`).snapshotChanges().subscribe(snapshot => {
       let existingUsername = snapshot.key;
       let existingUid = snapshot.payload.val();

       if ( existingUid === this.profile.userId ) {
         this.usernameChecked = false;
         this.usernameAvailable = true;
       } else if ( existingUsername ) {
         this.usernameAvailable = false;
       }
     });
   }
  }

  updateUsername() {
   let data = {}
   data[this.profile.username] = this.user.uid
   this.db.object(`/usernames`).update(data)
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/profile/profile.component.ts